import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';
import { initYaMaps } from 'vpl.tas';
import { holdCatalogPreloader, releaseCatalogPreloader } from 'vpl.tas';


export const ProjectsPage = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number],
    },
    data: ()=>{
        return {
            type: "",
            city: ""
        }
    },
    methods: {
        lazyLoad(link, append = true, filterMap = false){

            link = link.split('#')[0];
            let arRoute = link.split('?');
            let params = 'get_json=Y';
            if(arRoute[1]){
                params += '&' + arRoute[1];
            }

            if(this.type){
                params += '&type=' + this.type;
            }

            holdCatalogPreloader();
            $.ajax({
                url: arRoute[0] + '?' + params,
                method: 'GET',
                complete: () => releaseCatalogPreloader(),
                success: (response) => {
                    response = JSON.parse(response);
                    if(append){
                        this.struct[this.structKey].componentData.ITEMS = [...this.struct[this.structKey].componentData.ITEMS, ...response.struct[this.structKey].componentData.ITEMS];
                    }else{
                        this.struct[this.structKey].componentData.ITEMS = response.struct[this.structKey].componentData.ITEMS;
                        $('html, body').animate({
                            scrollTop: $(this.$el).find('.js-container').offset().top - 79
                        }, 500);
                    }
                    this.struct[this.structKey].componentData.PAGIN = response.struct[this.structKey].componentData.PAGIN;

                    if(filterMap){
                        //this.struct[this.structKey].componentData.MAP_ELEMS = response.struct[this.structKey].componentData.MAP_ELEMS;
                        this.setMapItems(response.struct[this.structKey].componentData.MAP_ELEMS)
                    }
                }
            });
        },
        applyFilter(type = ''){
            this.type = type;
            let link = window.location.href.split('#')[0];
            this.lazyLoad(link, false, true);
        },
        initMap(){

            this.map = new ymaps.Map("city-map", {
                center: ['45.356210', '36.467332'],
                zoom: 15,
                behaviors: ['default'],
                controls: []
            });

            this.map.behaviors.disable(['scrollZoom']);

            this.setMapItems(this.struct[this.structKey].componentData.MAP_ELEMS);

            this.map.controls.add('zoomControl', {
                size: 'small',
                float: 'none',
                position: {
                    top: $('#city-map').height() / 2 - 30,
                    right: '45px'
                }
            });

            self = this;
            let zoomRangeRatio =  $(window).width() < 768 ? 30 : 100;
            this.map.setBounds(this.map.geoObjects.getBounds(),
                {checkZoomRange:true, zoomMargin:zoomRangeRatio}).then(function(){ if(self.map.getZoom() > 14) self.map.setZoom(14);});

        },
        setMapItems(mapItems){
            var markers = [];
            var data = [];

            for(let i in mapItems){
                let mapitem = mapItems[i];
                markers.push([mapitem.LAT, mapitem.LON]);

                data.push({
                    "NAME": mapitem.NAME,
                    "PROPERTY_ADDRESS_CITY": mapitem.PROPERTY_CITY_VALUE,
                    "PROPERTY_ADDRESS_TYPE": mapitem.PROPERTY_TYPE_VALUE,
                    "ID": mapitem.ID,
                    "CITY": mapitem.PROPERTY_CITY_VALUE,
                    "LINK": mapitem.DETAIL_PAGE_URL
                });
            }

            this.map.geoObjects.each((geoObject) => {
                if (geoObject instanceof ymaps.ObjectManager) {
                    this.map.geoObjects.remove(geoObject);
                }
            });

            this.objectManager = new ymaps.ObjectManager({
                    clusterize: true,
                    clusterIcons: [
                        {
                            href: this.SITE_TEMPLATE_PATH + '/img/svg/claster-small.svg',
                            size: [40, 40],
                            offset: [-27.5, -42],
                            iconContentOffset: [23, 15],
                        },
                        {
                            href: this.SITE_TEMPLATE_PATH + '/img/svg/claster-small.svg',
                            size: [55, 55],
                            offset: [-27.5, -42],
                            iconContentOffset: [25, 25],
                        }],
                    clusterNumbers: [3],
                    clusterIconContentLayout: ymaps.templateLayoutFactory.createClass('<span style="font-weight: 600;font-size: 18px; color: #000">{{ properties.geoObjects.length }}</span>')
                });


            var MyBalloonLayout = ymaps.templateLayoutFactory.createClass(
                '<div class="popover">' +
                '<div class="popover__arrow"></div>' +
                '<div class="popover__inner">' +
                '<a class="popover__close" href="#">' +
                '<svg class="icon icon-close">' +
                '<use xlink:href="#icon-close"></use>' +
                '</svg>' +
                '</a>' +
                '$[[options.contentLayout observeSize minWidth=300 maxWidth=480]]' +
                '<span class="popover__tail"></span>' +
                '</div>' +
                '</div>', {
                    build: function () {
                        this.constructor.superclass.build.call(this);

                        this._$element = $('.popover', this.getParentElement());

                        this.applyElementOffset();

                        this._$element.find('.popover__close')
                            .on('click', $.proxy(this.onCloseClick, this));
                    },
                    clear: function () {
                        this._$element.find('.popover__close')
                            .off('click');

                        this.constructor.superclass.clear.call(this);
                    },
                    onSublayoutSizeChange: function () {
                        MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                        if (!this._isElement(this._$element)) {
                            return;
                        }

                        this.applyElementOffset();

                        this.events.fire('shapechange');
                    },
                    applyElementOffset: function () {
                        this._$element.css({
                            left: -(this._$element[0].offsetWidth / 2.45),
                            top: -(this._$element[0].offsetHeight + this._$element.find('.popover__arrow')[0].offsetHeight - 35)
                        });
                    },
                    onCloseClick: function (e) {
                        e.preventDefault();

                        this.events.fire('userclose');
                    },
                    getShape: function () {
                        if (!this._isElement(this._$element)) {
                            return MyBalloonLayout.superclass.getShape.call(this);
                        }

                        var position = this._$element.position();

                        return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                            [position.left, position.top], [
                                position.left + this._$element[0].offsetWidth,
                                position.top + this._$element[0].offsetHeight + this._$element.find('.popover__arrow')[0].offsetHeight
                            ]
                        ]));
                    },
                    _isElement: function (element) {
                        return element && element[0] && element.find('.popover__arrow')[0];
                    }
                });

            var collection = {
                type: "FeatureCollection",
                features: []
            };

            for (var i = 0; i < markers.length; i++) {
                var marker = markers[i];
                var item = data[i];

                var balloon = `
                <div class="ballon">
                        <div class="ballon__head">
                        <div class="baloon__head-text">
                            ${data[i].NAME}
                        </div>
                    </div>
                    <div class="baloon__body baloon__body--projects">
                        <div class="baloon__props">
                                <div style="${data[i].PROPERTY_ADDRESS_TYPE ? '' : 'display:none'}" class="baloon__line">
                                    <span class="baloon__props-title">Тип объекта</span>
                                    <span>${item.PROPERTY_ADDRESS_TYPE}</span>
                            </div>
                                <div style="${data[i].PROPERTY_ADDRESS_CITY ? '' : 'display:none'}" class="baloon__line">
                                    <span class="baloon__props-title">город</span>
                                    <span class="baloon__props-city">${item.PROPERTY_ADDRESS_CITY}</span>
                            </div>
                        </div>
                        <div class="baloon__props-btn">
                            <a href="${data[i].LINK}" class="btn btn--border">Подробнее</a>
                        </div>
                    </div>
                </div>
                `;

                collection.features.push({
                        type: 'Feature',
                        id: i,
                        geometry: {
                            type: 'Point',
                            coordinates: marker
                        },
                        properties: {
                            balloonContent: balloon,
                            hintContent: item.NAME,
                            id: item.ID,
                            city: item.CITY
                        },
                        options: {
                            balloonLayout: MyBalloonLayout,
                            balloonContentLayout: ymaps.templateLayoutFactory.createClass('<div class="popover__content">$[properties.balloonContent]</div>'),
                            balloonOffset: [83, -35],
                            iconColor: '#CE6B33',
                            iconLayout: 'default#imageWithContent',
                            iconImageHref: this.SITE_TEMPLATE_PATH + '/img/svg/metka.svg',
                            iconImageSize: [44, 53],
                            iconImageOffset: [-22, -53],
                            iconContentOffset: [0, 0],
                        }
                    }
                )
            }

            this.objectManager.add(collection);

            this.map.geoObjects.add(this.objectManager);

            this.objectManager.objects.events.add(['mouseenter', 'mouseleave'], (e) => {
                var objectId = e.get('objectId');
                if (e.get('type') == 'mouseenter') {
                    this.objectManager.objects.setObjectOptions(objectId, {
                        iconImageHref: this.SITE_TEMPLATE_PATH + '/img/svg/metka-h.svg'
                    });
                } else {
                    this.objectManager.objects.setObjectOptions(objectId, {
                        iconImageHref: this.SITE_TEMPLATE_PATH + '/img/svg/metka.svg'
                    });
                }
            });
            // self = this;
            // let zoomRangeRatio =  $(window).width() < 768 ? 30 : 100;
            // this.map.setBounds(this.map.geoObjects.getBounds(),
            //     {checkZoomRange:true, zoomMargin:100}).then(function(){ if(self.map.getZoom() > 14) self.map.setZoom(14);});
        },
        setCityFilter(event){
            let city = $(event.target).val();
            city ? this.objectManager.setFilter(`properties.city == ${'"'+city+'"'}`) : this.objectManager.setFilter();
            self = this;
            let zoomRangeRatio =  $(window).width() < 768 ? 30 : 100;
            this.map.setBounds(this.map.geoObjects.getBounds(),
                {checkZoomRange:true, zoomMargin:zoomRangeRatio}).then(function(){ if(self.map.getZoom() > 14) self.map.setZoom(14);});
        }
    },
    updated(){

    },
    mounted(){

        initYaMaps();

        let interval = setInterval(()=>{
            if(typeof ymaps !== "undefined"){

                ymaps.ready( () => {
                    this.initMap()

                    if(this.ancor){
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $("#" + this.ancor).offset().top - 70
                        }, 500);
                    }
                });

                clearInterval(interval);
            }
        }, 500);

        $(this.$el).find('.js-city-filter').niceSelect();
        $(this.$el).find('.js-city-filter').change((e) => this.setCityFilter(e));

        $(".js-list-close").on("click", function () {
            $('.js-city-filter').removeClass('open');
        });

    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH', 'ancor'])
    },
    template: `
<div style="display: contents;">
    <section v-if="this.struct[this.structKey].componentData.ITEMS" class="section section--gray js-container">
        <div class="container">
            <div class="projects__list">
                <div class="projects__list-filter">
                    <a href="#" @click.prevent="applyFilter()" :class="{'is-active': !this.type}" class="projects__list-filter-item js-filter-type">Все</a>
                    <a v-for="type in this.struct[this.structKey].componentData.TYPES" :class="{'is-active': this.type == type}" href="#" @click.prevent="applyFilter(type)" class="projects__list-filter-item js-filter-type">{{type}}</a>
                </div>
                <div class="projects__list-wp">

                    <a v-for="item in this.struct[this.structKey].componentData.ITEMS" :href="item.LINK" class="projects__item js-project-item">
                        <div class="projects__item-img">
                            <img v-if="item.CARD_TYPE == 'photo'" class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.PREVIEW" :alt="item.NAME" :title="item.NAME">
                            <video v-if="item.CARD_TYPE == 'video'" preload="metadata" playsinline="" webkit-playsinline="" loop="" muted="">
                                <source :src="item.PREVIEW" :type="item.FILE_TYPE">
                            </video>
                        </div>
                        <div class="projects__item-top">
                            <div v-if="item.TYPE" class="projects__item-tag">
                                {{item.TYPE}}
                            </div>
                            <div class="projects__item-title">
                                {{item.NAME}}
                                <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                            </div>
                            <div class="projects__item-date">
                                {{item.YEAR}}
                            </div>
                        </div>
                        <div v-if="item.CARD_TYPE == 'photo'" class="projects__item-icon">
                            <svg class="ico ico-foto" width="13" height="13" aria-hidden="true"><use xlink:href="#ico-foto"></use></svg>
                            {{item.GALLERY_COUNT}}
                        </div>
                        <div v-if="item.CARD_TYPE == 'video'" class="projects__item-icon">
                            <svg class="ico ico-play" width="17" height="18" aria-hidden="true"><use xlink:href="#ico-play"></use></svg>
                        </div>
                    </a>

                    <div class="content-nav">
                        <ul class="content-nav__list">
                            <template v-for="link in this.struct[this.structKey].componentData.PAGIN">
                                <li v-if="link.type==='left_arrow'" class="content-nav__list-item content-nav__list-item--prev">
                                    <a :href="link.link" @click.prevent="lazyLoad(link.link, false)" data-skip="y">
                                        <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                                    </a>
                                </li>
                                <li v-if="link.type==='number'" :class="{active: link.selected}" class="content-nav__list-item"><a @click.prevent="lazyLoad(link.link, false)" data-skip="y" :href="link.selected ? '#' : link.link">{{ link.text }}</a></li>
                                <li v-if="link.type==='dots'" class="content-nav__list-item"><a @click.prevent="lazyLoad(link.link, false)" data-skip="y" :href="link.link">...</a></li>
                                <li v-if="link.type==='right_arrow'" class="content-nav__list-item content-nav__list-item--next">
                                    <a :href="link.link" data-skip="y" @click.prevent="lazyLoad(link.link, false)">
                                        <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                                    </a>
                                </li>
                            </template>
                        </ul>
                        <template v-for="link in this.struct[this.structKey].componentData.PAGIN">
                            <a v-if="link.type==='showmore'" href="#" @click.prevent="lazyLoad(link.link)" class="btn btn--border">Показать ещё</a>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section v-if="this.struct[this.structKey].componentData.MAP_ELEMS" class="section project-map" id="map">
        <div class="container">
            <div class="section__heading">
                <div class="section__title-wp">
                    <h2 class="section__title">
                        Проекты на карте
                    </h2>
                </div>
                <div class="section__nav">
                    <div class="sort__select-wp">
                        <select name="" id="" class="sort__select js-city-filter">
                            <option value="">Все города</option>
                            <option v-for="city in this.struct[this.structKey].componentData.CITY" :value="city">{{city}}</option>
                        </select>
                        <div class="catalog__overlay js-catalog-overlay"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="city__map js-city-map" id="city-map">
        </div>
    </section>
</div>
    `
}